import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let options = {
      threshold: 0.5
    };

    let videos = [].slice.call(document.querySelectorAll('.core-video__video'));

    if ('IntersectionObserver' in window) {
      let videoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.classList.add('is-visible');
          } else {
            video.pause();
            video.classList.remove('is-visible');
            video.classList.remove('is-playing')
          }
        });
      }, options);

      videos.forEach(function(video) {
        videoObserver.observe(video);
      });
    } else {
      document.addEventListener('scroll', toggleFallback);
    }
  }

  togglePlay(event) {
    let video = event.currentTarget.querySelector('.core-video__video');
      video.classList.toggle('is-playing')
    if (video.paused) {
      video.play()
    }
    else {
      video.pause()
    }
  }

  toggleFallback() {
    videos.forEach(function(video) {
      if (video.getBoundingClientRect().top <= window.innerHeight && video.getBoundingClientRect().bottom >= 0) {
         video.classList.add('-is-visible');
      } else {
        video.pause();
        video.classList.remove('is-visible');
        video.classList.remove('is-playing')
      }
    });
  }
}
